import React from 'react';
import { graphql } from 'gatsby';
import GetSEOData from '../data/SEO';
import SEO from '../components/SEO';
import AnyQuestions from '../components/AnyQuestions';
import ModularHero from '../components/ModularHero';
import ModularParagraph from '../components/ModularParagraph';
import ModularPostcode from '../components/ModularPostcode';
import ModularContact from '../components/ModularContact';
import ModularImageHeaderParagraph from '../components/ModularImageHeaderParagraph';
import ModularHeaderImage from '../components/ModularHeaderImage';
import ModularIconHeaderPath from '../components/ModularIconHeaderPath';
import ModularHeaderNumberText from '../components/ModularHeaderNumberText';
import ModularFaqs from '../components/ModularFaqs';
import ModularCarousel from '../components/ModularCarousel';
import ModularCardGrid from '../components/ModularCardGrid';
import ModularImageBanner from '../components/ModularImageBanner';
import ModularButtonVideo from '../components/ModularButtonVideo';
import ModularImageBody from '../components/ModularImageBody';
import ModularParagraphButton from '../components/ModularParagraphButton';
import ModularHeaderParagraphList from '../components/ModularHeaderParagraphList';
import ModularProductCards from '../components/ModularProductCards';
import ModularBlogNewsCarousel from '../components/ModularBlogNewsCarousel';
import ModularHeaderImageHeadingParagraph from '../components/ModularHeaderImageHeadingParagraph';
import ModularCustomerReview from '../components/ModularCustomerReview';
import ModularInfluencerForm from '../components/ModularInfluencerForm';
import ModularCardCarousel from '../components/ModularCarouselCard';
import ModularPrizeDrawForm from '../components/ModularPrizeDrawForm';
import ModularCardGridOverlap from '../components/ModularCardGridOverlap';
import ModularHeadingParagraphButton from '../components/ModularHeadingParagraphButton';
import ModularHeaderBodyImageColumn from '../components/ModularHeaderBodyImageColumn';
import ModularHeading from '../components/ModularHeading';
import ModularHeadingImageDropdownBox from '../components/ModularHeadingImageDropdownBox';
import ModularHeadingImageDropdownTableBox from '../components/ModularHeadingImageDropdownTableBox';
import ModularHeadingIconTextBox from '../components/ModularHeadingIconTextBox';
import ModularHeadingContentButtonSpeedAnimation from '../components/ModularHeadingContentButtonSpeedAnimation';
import ModularHeadingIconHeaderParagraphArrow from '../components/ModularHeadingIconHeaderParagraphArrow';
import ModularButtonBlock from '../components/ModularButtonBlock';
import ModularFacebookEvent from '../components/ModularFacebookEvent';
import ModularNewsletterForm from '../components/ModularNewsletterForm';
import ModularHumanHelpForm from '../components/ModularHumanHelpform';
import ModularRegisterInterestForm from '../components/ModularRegisterInterestForm';

const ModularTemplate = ({ data }) => {
  const modularPageData = data.datoCmsModularPage;
  const GetModularComponent = (type, data) => {
    switch (type) {
      case 'DatoCmsHumanHelpForm':
        return <ModularHumanHelpForm data={data} />;
      case 'DatoCmsHero':
        return <ModularHero data={data} />;
      case 'DatoCmsParagraph':
        return <ModularParagraph data={data} />;
      case 'DatoCmsImageHeaderParagraph':
        return <ModularImageHeaderParagraph data={data} />;
      case 'DatoCmsBottomPostcode':
        return <ModularPostcode data={data} />;
      case 'DatoCmsContact':
        return <ModularContact data={data} />;
      case 'DatoCmsHeaderImage':
        return <ModularHeaderImage data={data} />;
      case 'DatoCmsIconHeaderPath':
        return <ModularIconHeaderPath data={data} />;
      case 'DatoCmsHeaderNumberText':
        return <ModularHeaderNumberText data={data} />;
      case 'DatoCmsModularFaq':
        return <ModularFaqs data={data} />;
      case 'DatoCmsCarousel':
        return <ModularCarousel data={data} />;
      case 'DatoCmsCardGrid':
        return <ModularCardGrid data={data} />;
      case 'DatoCmsBannerImage':
        return <ModularImageBanner data={data} />;
      case 'DatoCmsHeadingBodyImageVideoButton':
        return <ModularButtonVideo data={data} />;
      case 'DatoCmsImageBodyBlock':
        return <ModularImageBody data={data} />;
      case 'DatoCmsParagraphButton':
        return <ModularParagraphButton data={data} />;
      case 'DatoCmsHeaderParagraphList':
        return <ModularHeaderParagraphList data={data} />;
      case 'DatoCmsProductCardsBlock':
        return <ModularProductCards data={data} />;
      case 'DatoCmsBlogAndNewsCarousel':
        return <ModularBlogNewsCarousel data={data} />;
      case 'DatoCmsHeaderImageHeadingParagraph':
        return <ModularHeaderImageHeadingParagraph data={data} />;
      case 'DatoCmsCustomerReviewBlock':
        return <ModularCustomerReview data={data} />;
      case 'DatoCmsInfluencerForm':
        return <ModularInfluencerForm data={data} />;
      case 'DatoCmsQuizForm':
        return <ModularPrizeDrawForm data={data} />;
      case 'DatoCmsCardCarousel':
        return <ModularCardCarousel data={data} />;
      case 'DatoCmsCardGridOverlap':
        return <ModularCardGridOverlap data={data} />;
      case 'DatoCmsHeadingParagraphButton':
        return <ModularHeadingParagraphButton data={data} />;
      case 'DatoCmsHeaderBodyImageColumn':
        return <ModularHeaderBodyImageColumn data={data} />;
      case 'DatoCmsHeading':
        return <ModularHeading data={data} />;
      case 'DatoCmsHeadingImageDropdownBox':
        return <ModularHeadingImageDropdownBox data={data} />;
      case 'DatoCmsHeadingImageDropdownTableBox':
        return <ModularHeadingImageDropdownTableBox data={data} />;
      case 'DatoCmsHeadingIconTextBoxBlock':
        return <ModularHeadingIconTextBox data={data} />;
      case 'DatoCmsHeadingContentButtonSpeedAnimation':
        return <ModularHeadingContentButtonSpeedAnimation data={data} />;
      case 'DatoCmsHeadingIconHeaderParagraphArrowBlock':
        return <ModularHeadingIconHeaderParagraphArrow data={data} />;
      case 'DatoCmsButtonBlock':
        return <ModularButtonBlock data={data} />;
      case 'DatoCmsFacebookEvent':
        return <ModularFacebookEvent data={data} />;
      case 'DatoCmsNewsletterForm':
        return <ModularNewsletterForm data={data} />;
      case 'DatoCmsRegisterInterestForm':
        return <ModularRegisterInterestForm data={data} />;
    }
    return null;
  };
  let { title, description } = GetSEOData(modularPageData.slug);

  return (
    <div className="bootstrap">
      <div className="modular-page-container">
        <SEO
          title={modularPageData.seo?.title ?? title}
          description={modularPageData.seo?.description ?? description}
          metaTags={modularPageData.seo}
        />
        <div className={`${modularPageData.slug}-modular-page-container`}>
          {modularPageData.modularPageContent?.map((component) => {
            return GetModularComponent(component.internal.type, component);
          })}
          <AnyQuestions />
        </div>
      </div>
    </div>
  );
};

export default ModularTemplate;
export const query = graphql`
  query ($id: String!) {
    datoCmsModularPage(id: { eq: $id }) {
      slug
      id
      seo {
        title
        description
        twitterCard
        image {
          gatsbyImageData
        }
      }
      modularPageContent {
        ...ModularHumanHelpForm
        ...ModularHero
        ...ModularParagraph
        ...ModularImageHeaderParagraph
        ...ModularPostcode
        ...ModularContact
        ...ModularHeaderImage
        ...ModularIconHeaderPath
        ...ModularHeaderNumberText
        ...ModularFaqs
        ...ModularCarousel
        ...ModularCardGrid
        ...ModularImageBanner
        ...ModularButtonVideo
        ...ModularImageBody
        ...ModularParagraphButton
        ...ModularHeaderParagraphList
        ...ModularProductCards
        ...ModularBlogAndNewsCarousel
        ...ModularHeaderImageHeadingParagraph
        ...ModularCustomerReview
        ...ModularInfluencerForm
        ...ModularPrizeDrawForm
        ...ModularCardCarousel
        ...ModularCardGridOverlap
        ...ModularHeadingParagraphButton
        ...ModularHeaderBodyImageColumn
        ...ModularHeading
        ...ModularHeadingImageDropdownBox
        ...ModularHeadingImageDropdownTableBox
        ...ModularHeadingIconTextBox
        ...ModularHeadingContentButtonSpeedAnimation
        ...ModularHeadingIconHeaderParagraphArrow
        ...ModularButtonBlock
        ...ModularFacebookEvent
        ...ModularNewsletterForm
        ...ModularRegisterInterestForm
      }
    }
  }
`;
